<template>
    <div>
      <v-dialog v-model="dialog" max-width="60%" persistent>
          <v-card>
              <v-card-title>
                  <span class="headline">Danh sách file từ Google Driver</span>
              </v-card-title>
              <v-card-text>
              <v-container>
                  <v-row v-for="(file, index ) in files" :key="file._id">
                      <v-col cols="12" sm="8">
                          <span class="text-no-wrap"> {{ (index + 1) + '.' }} {{ file.name }} </span>
                      </v-col>
                      <v-col cols="12" sm="2">
                          <v-icon @click="deleteFile(file)"> delete </v-icon>
                      </v-col>
                  </v-row>
              </v-container>

              <v-divider></v-divider>
              <v-toolbar flat>
                  <v-btn color="primary" width="120px" @click="cancelUpload">{{ $t('common.cancel') }}</v-btn>

                  <v-spacer> </v-spacer>

                  <v-btn color="primary" @click="driveIconClicked" width="120px" class="mr-5">
                      {{ $t('common.chosen_file') }}
                  </v-btn>

                  <v-btn color="primary" @click="closeDialog" width="120px">
                      {{ $t('common.save') }}
                  </v-btn>                               
              </v-toolbar>
              </v-card-text>
          </v-card>
      </v-dialog>
    </div>
</template>

<script>
  export default {
    name: "google-drive-select",
    data: ()=> ({
        files: [],
        overlay: false,
        dialog: false,
        tempAttachments: [],
        attachments: [],
        pickerApiLoaded: false,
        developerKey: "AIzaSyAftCx6QTvyEDDUx9NePOhF6RNb2a5X3Tw",
        clientId: "564735479971-2maclfcf937a5dihbe3p43arfbgn0jkc.apps.googleusercontent.com",
        scope: "https://www.googleapis.com/auth/drive.file",
        oauthToken: null
    }),

    props: {
    // Use "value" to enable using v-model
      value: Boolean,
      editedItem: Object
    },

    components: {
    },

    mounted() {
      let gDrive = document.createElement("script");
      gDrive.setAttribute("type", "text/javascript");
      gDrive.setAttribute("src", "https://apis.google.com/js/api.js");
      document.head.appendChild(gDrive);
    },

    created() {  
      this.dialog = this.value;
      this.files = [].concat(this.editedItem.gDrive);
      console.log(this.files.length);
    },

    methods: {
      // function called on click of drive icon
      async driveIconClicked() {
        await gapi.load("auth2", () => {
          gapi.load("picker", () => {
              this.pickerApiLoaded = true;
          });

          gapi.auth2.authorize(
            {
              client_id: this.clientId,
              scope: this.scope,
              immediate: false
            },
            this.handleAuthResult
          );
        });
        
      },

      handleAuthResult(authResult) {
        if (authResult && !authResult.error) {
          this.oauthToken = authResult.access_token;
          this.createPicker();
        }
      },

      // Create and render a Picker object for picking user Photos.
      createPicker() {
        if (this.pickerApiLoaded && this.oauthToken) {
          var picker = new google.picker.PickerBuilder()
            .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
            .addView(google.picker.ViewId.DOCS)
            .setOAuthToken(this.oauthToken)
            .setDeveloperKey(this.developerKey)
            .setCallback(this.pickerCallback)
            .build();
          picker.setVisible(true);
        }

      },
      async pickerCallback(data) {
        const self = this;
        if (data.docs && data.docs.length > 0) {
          try {
              const response =  await self.$http.post("/gdrive", data.docs);
              console.log(response);
              if (response.data.success) {
                  self.files = self.files.concat(response.data.data);
              } else {
                  alert('Select error!');
              }
          } catch(e) {
              console.log(e.stack);
              alert("Request error!");
          }
        }
        
      },

      cancelUpload() {
          this.dialog = false;
          this.$emit('cancelUploadGDrive', this.dialog);
      },

      closeDialog() {
        this.dialog = false;
        this.editedItem.gDrive = [].concat(this.files);
        this.$emit('closeDialogGDrive', this.dialog);
      },

      deleteFile(file) {
        // const agree = confirm(i18n.t('common.confirm_delete'));
        this.files.splice(this.files.indexOf(file), 1);
      },
    }
  }
</script>

